/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "58c03b31566ffc539847ed431ce14fffb369c85f";
